<template>
  <div class="notice-history-page">
    <div class="filter-box">
      <a-form layout="inline">
        <a-form-item>
          <a-input v-model="form.id" placeholder="请输入ID" allow-clear />
        </a-form-item>
        <a-form-item>
          <a-input v-model="form.channel_name" placeholder="请输入通道名称" allow-clear />
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.status" placeholder="请选择状态" allow-clear>
            <a-select-option :value="1">成功</a-select-option>
            <a-select-option :value="2">失败</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-range-picker
            v-model="form.dateRange"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始时间', '结束时间']"
            separator="至"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search">查询</a-button>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
      </a-form>
    </div>
    <vxe-table :border="true" :data="dataSource" :height="tableHeight" resizable :loading="loading">
      <vxe-column field="id" title="ID" width="120" />
      <vxe-column field="channel_name" title="通道名称" />
      <vxe-column field="gateway" title="网关类型" />
      <vxe-column field="create_time" title="创建时间" />
      <vxe-column field="done_time" title="完成时间" />
      <vxe-column field="status" title="状态" width="100">
        <template #default="{ row }">
          <a-popover placement="topLeft" :content="getContent(row)" trigger="hover">
            <div v-if="row.status === 1">
              <a-tag color="green">成功</a-tag>
            </div>
            <div v-else>
              <a-tag color="red">失败</a-tag>
            </div>
          </a-popover>
        </template>
      </vxe-column>
      <vxe-column field="ope" title="操作">
        <template #default="{ row }">
          <a-button size="small" @click="viewDetail(row)">查看详情</a-button>
          <a-button v-if="row.status !== 1" size="small" v-permission="PERMISSIONS.NOTICE_RETRY" @click="reSend(row)">重新发送</a-button>
        </template>
      </vxe-column>
    </vxe-table>
    <div class="pagination-wrapper">
      <a-pagination
        v-model="pagination.current"
        size="small"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :show-total="pagination.showTotal"
        @change="pageChange"
      />
    </div>
  </div>
</template>

<script>
import { getNoticeHistoryList, retryNotice } from '@/api/notice'

export default {
  data() {
    return {
      dataSource: [],
      tableHeight: null,
      loading: false,
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showTotal: total => `共 ${total} 条`
      },
      form: {
        id: '',
        channel_name: '',
        status: undefined,
        dateRange: null
      }
    }
  },
  created() {
    this.restoreState()
  },
  mounted() {
    this.calcTableHeight()
    window.addEventListener('resize', this.calcTableHeight)
    this.fetchData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight)
  },
  methods: {
    fetchData(params = {}) {
      this.loading = true
      const query = {
        page_num: this.pagination.current,
        page_size: this.pagination.pageSize,
        ...this.buildQuery(),
        ...params
      }
      getNoticeHistoryList(query)
        .then(res => {
          this.loading = false
          if (res.code === 0) {
            this.dataSource = res.data.list
            this.pagination.total = res.data.total
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    buildQuery() {
      const query = {}
      if (this.form.id) {
        query.id = Number(this.form.id)
      }
      if (this.form.channel_name) {
        query.channel_name = this.form.channel_name
      }
      if (this.form.status) {
        query.status = this.form.status
      }
      if (this.form.dateRange && this.form.dateRange.length === 2) {
        query.start_time = this.form.dateRange[0]
        query.end_time = this.form.dateRange[1]
      }
      return query
    },
    search() {
      this.pagination.current = 1
      this.fetchData()
    },
    reset() {
      this.form = {
        id: '',
        channel_name: '',
        status: undefined,
        dateRange: null
      }
      this.pagination.current = 1
      this.fetchData()
    },
    pageChange(e) {
      this.pagination.current = e
      this.fetchData()
    },
    reSend(row) {
      const params = {
        history_id: [row.id]
      }
      retryNotice(params).then(res => {
        if (res.code === 0) {
          this.$message.success('重新发送成功')
          this.fetchData()
        }
      })
    },
    getContent(row) {
      return `code: ${row.result?.errcode}; msg: ${row.result?.errmsg}`
    },
    restoreState() {
      const query = this.$route.query
      if (query.page) {
        this.pagination.current = Number(query.page)
      }
      if (query.id) {
        this.form.id = query.id
      }
      if (query.channel_name) {
        this.form.channel_name = query.channel_name
      }
      if (query.status) {
        this.form.status = Number(query.status)
      }
      if (query.start_time && query.end_time) {
        this.form.dateRange = [query.start_time, query.end_time]
      }
    },
    viewDetail(row) {
      this.$router.push({
        path: '/notice-history-detail/' + row.id,
        query: {
          from: 'notice-history',
          page: this.pagination.current,
          id: this.form.id || undefined,
          channel_name: this.form.channel_name || undefined,
          status: this.form.status || undefined,
          start_time: this.form.dateRange ? this.form.dateRange[0] : undefined,
          end_time: this.form.dateRange ? this.form.dateRange[1] : undefined
        }
      })
    },
    calcTableHeight() {
      const pageHeight = window.innerHeight
      const headerHeight = 64
      const contentMargin = 48
      const contentPadding = 48
      const paginationHeight = 52
      const filterBox = document.querySelector('.notice-history-page .filter-box')
      const filterHeight = filterBox ? filterBox.clientHeight : 52
      const extraGap = 0
      this.tableHeight = pageHeight - headerHeight - contentMargin - contentPadding - filterHeight - paginationHeight - extraGap
    }
  }
}
</script>

<style scoped>
.notice-history-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.filter-box {
  margin-bottom: 10px;
  flex-shrink: 0;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  flex-shrink: 0;
}
</style>
